var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"landing-page"},[_c('hero'),_c('access'),_vm._m(0),_c('apps'),_c('features'),_c('join')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('hr')])
}]

export { render, staticRenderFns }